export {};

declare global {
  interface Array<T> {
    excludes(value: T): boolean;
    filterUniqueBy(selector: PropertySelector<T>): T[];
  }
}

Array.prototype.excludes = function <T>(this: T[], value: T, options?: { ignoreCase: boolean }): boolean {
  if (options?.ignoreCase) {
    return !this.map((item: T) => item?.toString().toLowerCase()).includes(value.toString().toLowerCase());
  }

  return !this.includes(value);
};

type PropertySelector<T> = (item: T) => unknown;

Array.prototype.filterUniqueBy = function <T>(this: T[], selector: PropertySelector<T>): T[] {
  const seen = new Set<unknown>();
  return this.filter(item => {
    const key = selector(item);

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);

    return true;
  });
};
